import { createApp } from 'vue';

import App from './App.vue';
import { createWidgetRuntime } from './runtime';

// 被宿主 iframe 嵌入时 window.parent 就是宿主；顶层直接打开时没有父窗口，
// 精确模式可由首个白名单帧绑定宿主；通配模式只接受已有父窗口。
const parentWindow = window.parent === window ? null : window.parent;
const runtime = createWidgetRuntime({ parentWindow, selfWindow: window });
runtime.start();

createApp(App, { session: runtime.session }).mount('#app');

// 页面卸载：摘掉宿主监听并停止会话（令牌/草稿/在飞结果一并作废）
window.addEventListener('beforeunload', () => {
  runtime.stop();
});
